import service from "./service";

export const updateCustomization = (data) => {
  return service.post('api/admin/config/update', data);
};

export const findByDomainCustomization = (domain) => {
  return service.get(`api/admin/config/find-by-domain/${domain}`);
};
